interface UserAvatarProps {
  user: {
    name?: string;
    image?: string | null;
    color?: string;
  };
  size?: string; // e.g. "w-14", "w-10" (default w-14)
  className?: string;
}

export const UserAvatar = (
  { user, size = "w-14", className = "" }: UserAvatarProps & {
    user: { frame?: string };
  },
) => {
  const frame = user.frame || "circle";
  const roundedClass = frame === "square" ? "rounded-none" : "rounded-full";

  return (
    <div
      class={`${roundedClass} flex items-center justify-center font-bold overflow-hidden ${size} ${className} ${
        user.color ? "border-2" : "bg-primary text-primary-content"
      }`}
      style={user.color
        ? { borderColor: user.color, backgroundColor: user.color }
        : {}}
    >
      {user.image
        ? (
          <img
            src={user.image}
            alt={user.name}
            class="w-full h-full object-cover"
          />
        )
        : (
          <span class={size === "w-14" ? "text-base" : "text-xs"}>
            {user.name?.charAt(0).toUpperCase() || "U"}
          </span>
        )}
    </div>
  );
};
